import { BsPersonWorkspace } from 'react-icons/bs';
import { MdEngineering } from 'react-icons/md';
import { GrUserWorker } from 'react-icons/gr';
import { FcLeave } from 'react-icons/fc';
import { RenderTiles } from '../../components/common';
import ChildHeader from '../../components/ui/ChildHeader';

const tiles = [
  {
    sNo: 1,
    link: '/admin/monthlysalaryStaffList',
    isLink: true,
    icon: <MdEngineering size="5rem" color="#343a40" />,
    p: 'Monthly Salary',
    span: 'Staff',
    isIcon: true,
  },

  {
    sNo: 3,
    link: '/admin/monthlysalaryContractualList',
    isLink: true,
    icon: <BsPersonWorkspace size="5rem" color="#087f5b" />,
    p: 'Monthly Salary',
    span: 'Contractual',
    isIcon: true,
  },
  {
    sNo: 2,
    link: '/admin/monthysalaryoperatorList',
    isLink: true,
    icon: <GrUserWorker size="5rem" color="#245278" />,
    p: 'Monthly Salary',
    span: 'Operator',
    isIcon: true,
  },
  {
    sNo: 2,
    link: '/admin/annualLeavesList',
    isLink: true,
    icon: <FcLeave size="5rem" color="#245278" />,
    p: 'Annual',
    span: 'Leaves',
    isIcon: true,
  },
];

const Tiles = () => {
  return (
    <>
      <ChildHeader text="Salary Management" />
      <RenderTiles
        tilesObj={tiles}
        height="100vh"
        justify="start"
        columns="0"
      />
    </>
  );
};

export default Tiles;
